/** `from` value a document page uses to offer "Back to Document Search". */
export const DOCUMENT_SEARCH_ORIGIN = 'meta-search';
